import * as React from 'react'
import {Dialog, DialogBody, DialogHeading} from '@frontrow/console/src/components/ui/dialog'
import {Button} from '@frontrow/console/src/components/button'
import {useSafeCallbackExtraDeps, unCallbackFn} from '@freckle/react-hooks'

import {type BasicDistrictT} from '@frontrow/console/src/models/district'
import DistrictForm from '@frontrow/console/src/components/pages/districts-page/district-form'
import * as style from './district-create-button-modal.module.scss'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  createDistrict: (districtData: BasicDistrictT) => Promise<unknown>
}

export default function DistrictCreateButtonModal(props: Props): React.ReactElement {
  const {isOpen, open, close} = useModalForm()

  const submitForm = useSafeCallbackExtraDeps<
    (
      districtData: BasicDistrictT,
      _clearClassLinkOneRosterToken: boolean,
      _shouldDeleteCleverAndClasslinkAssociations?: boolean
    ) => void,
    {
      createDistrict: (districtData: BasicDistrictT) => Promise<unknown>
      close: () => void
    }
  >(
    ({createDistrict, close}) =>
      (
        districtData: BasicDistrictT,
        _clearClassLinkOneRosterToken: boolean,
        _shouldDeleteCleverAndClasslinkAssociations?: boolean
      ) => {
        createDistrict(districtData).then(() => close())
      },
    [],
    {
      createDistrict: {value: props.createDistrict, comparator: () => true},
      close: {value: close, comparator: () => true}
    }
  )

  return (
    <React.Fragment>
      <Button onClick={open} addClass={style.districtButtonModal}>
        Add a District
      </Button>
      <Dialog open={isOpen} onClose={close}>
        <DialogHeading>Create District</DialogHeading>
        <DialogBody>
          <DistrictForm onSubmit={unCallbackFn(submitForm)} onCancel={close} isCreate />
        </DialogBody>
      </Dialog>
    </React.Fragment>
  )
}
